import React, { useEffect } from 'react'

declare global {
  namespace JSX {
    interface IntrinsicElements {
      'wistia-player': React.DetailedHTMLProps<
        React.HTMLAttributes<HTMLElement>,
        HTMLElement
      > & {
        'media-id': string
        aspect?: string
      }
    }
  }
}

const WistiaPlayer = ({ wistiaId }: { wistiaId: string }) => {
  useEffect(() => {
    // Add Wistia player script
    const script1 = document.createElement('script')
    script1.src = 'https://fast.wistia.com/player.js'
    script1.async = true
    document.body.appendChild(script1)

    // Add specific embed script (ES module)
    const script2 = document.createElement('script')
    script2.src = `https://fast.wistia.com/embed/${wistiaId}.js`
    script2.async = true
    script2.type = 'module'
    document.body.appendChild(script2)

    // Add placeholder style
    const style = document.createElement('style')
    style.innerHTML = `
      wistia-player[media-id='${wistiaId}']:not(:defined) {
        background: center / contain no-repeat url('https://fast.wistia.com/embed/medias/${wistiaId}/swatch');
        display: block;
        filter: blur(5px);
        padding-top: 56.25%;
      }
    `
    document.head.appendChild(style)

    return () => {
      document.body.removeChild(script1)
      document.body.removeChild(script2)
      document.head.removeChild(style)
    }
  }, [wistiaId])

  return (
    <div>
      <wistia-player media-id={wistiaId} aspect="1.7777777777777777" />
    </div>
  )
}

export default WistiaPlayer
